import {
    IonContent,
    IonPage,
    useIonViewDidEnter,
    useIonViewDidLeave,
    IonAlert,
    IonLoading,
    IonDatetime,
} from '@ionic/react'
import CopyToClipboard from 'react-copy-to-clipboard'
import dayjs from 'dayjs'
import { useHistory } from 'react-router'
import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
    // getWechatQrcode,
    getWechatBotSettings,
    unbindBotAdmin,
    postUserAction,
    updateBoReplySettings,
    unbindWx,
} from '../service/api/bot'
import Header from '../components/Header'
import './WechatBot.css'
import { ReduxStore } from '../redux/reducers'
import { BotSettings, BotSet } from '../model/bot.model'
import { setBotSettingsInfo } from '../redux/actions/settings'
import { BindWechatPage, GroupDataStatisticsPage } from '../conf/routePath'
import {
    getKnowledgeList,
    getKnowledgeQAHistory,
    getReplyConfig,
    listIdentityQuestions,
    updateReplyConfig,
} from '../service/api/knowledge'
import { UserModel } from '../model/user.model'
import { LoadingProps } from '../model/toast.model'
import Toast from '../components/Toast'
import ContactSelector from '../components/ContactSelector'
import { ArrowRightIcon } from '../conf/images'

const BotRunStatistics = () => {
    const userInfo = useSelector<ReduxStore, UserModel>(
        (store) => store.userInfo as UserModel
    )

    const [knoledgeCount, setKonledgeCont] = React.useState(0)

    const [unKonownKonledgeCount, setUnkonownKonledgeCount] = React.useState(0)

    const [messageDetail, setMessageDetail] = React.useState({
        messageCount: 0,
        recallRate: 0,
    })

    useIonViewDidEnter(() => {
        getKnowledgeList({
            appHash: userInfo.app_hash,
            pagination: { page: 1, page_size: 1 }, // 只是取 cont 总数,这个 page 数据取一条就可以了
            tagId: userInfo.custom_tag_id,
        }).then((res) => setKonledgeCont(res.data.getKnowledgeList.count))

        listIdentityQuestions({
            appHash: userInfo.app_hash,
            pagination: { page: 1, page_size: 1 },
        }).then((res) =>
            setUnkonownKonledgeCount(res.data.listIdentityQuestions.count)
        )
        const endDate = dayjs()
        const startDate = endDate.subtract(7, 'd')
        getKnowledgeQAHistory({
            startDate: startDate.format('YYYYMMDD'),
            endDate: endDate.format('YYYYMMDD'),
            appHash: userInfo.app_hash,
        }).then((res) => {
            const messageCount = res.data.getQABotHistory.reduce((n, i) => {
                return n + i.receiveMessageNumber
            }, 0)
            const recallCount = res.data.getQABotHistory.reduce((n, i) => {
                return n + i.recallNumber
            }, 0)

            setMessageDetail({
                messageCount,
                recallRate: messageCount === 0 ? 0 : recallCount / messageCount,
            })
        })
    }, [])

    return (
        <div className='info-section'>
            <p className='section-title'>机器人运行情况统计</p>

            <div className='historyRunStatistics'>
                <div className='historyRunStatisticsItem'>
                    <p className='historyRunStatisticsItemTitle'>
                        已掌握自定义知识
                    </p>
                    <p>{knoledgeCount}个</p>
                </div>
                <div className='historyRunStatisticsItem'>
                    <p className='historyRunStatisticsItemTitle'>
                        待学习知识数
                    </p>
                    <p>{unKonownKonledgeCount}个</p>
                </div>
                <div className='historyRunStatisticsItem'>
                    <p className='historyRunStatisticsItemTitle'>
                        近七日收发消息数
                    </p>
                    <p>{messageDetail.messageCount}条</p>
                </div>
                <div className='historyRunStatisticsItem'>
                    <p className='historyRunStatisticsItemTitle'>
                        近七日召回率
                    </p>
                    <p>
                        {messageDetail.recallRate &&
                            (messageDetail.recallRate * 100).toFixed(2)}
                        %
                    </p>
                </div>
            </div>
        </div>
    )
}

type UserType = 'bot' | 'admin'
interface WechatUserCompProps {
    type: 'bot' | 'admin'
    settings: BotSettings
    onUnbind?: (type: UserType) => void
}
const WechatUserComp = (props: WechatUserCompProps) => {
    const { type = 'bot', settings, onUnbind = () => undefined } = props
    return (
        <div className='wechat-bot'>
            <div className='wechat-bot-info'>
                <img
                    className='bot-icon'
                    src={
                        type === 'bot'
                            ? settings.bot_head_url
                            : settings.admin_head_url
                    }
                    alt='icon'
                />
                <span>
                    {type === 'bot'
                        ? settings.bot_nickname
                        : settings.admin_nickname}
                </span>
            </div>
            <p className='unbind-button' onClick={() => onUnbind(type)}>
                解绑
            </p>
        </div>
    )
}
interface WechatAdminCompProps {
    onUnbind?: (type: UserType) => void
    settings: BotSettings
}
const WechatAdminComp = ({ onUnbind, settings }: WechatAdminCompProps) => {
    return (
        <div className='wechat-admin info-section'>
            <div className='section-title'>
                <p>管理员</p>
                <p className='section-subtitle'>
                    通过管理员的微信私聊机器人，可以对机器人进行管理。支持的命令为：配置、学习、帮助
                </p>
            </div>

            <WechatUserComp
                settings={settings}
                type='admin'
                onUnbind={onUnbind}
            />
        </div>
    )
}
interface BotDefaultResponseProps {
    onBlur?: () => void
    value?: string
    onChange?: (value: string) => void
}
const BotDefaultResponse = ({
    onBlur,
    value,
    onChange,
}: BotDefaultResponseProps) => {
    return (
        <div className='bot-default-response info-section'>
            <p className='section-title'>
                当机器人遇到不理解的问题时，会回复以下内容
            </p>
            <textarea
                className='response-edit'
                onBlur={() => {
                    onBlur && onBlur()
                }}
                placeholder='请输入机器人默认回复'
                value={value}
                onChange={(e) => onChange && onChange(e.target.value)}
            />
        </div>
    )
}
interface BindBotAdminProps {
    activeCode: string
}
const BindBotAdmin = ({ activeCode }: BindBotAdminProps) => {
    const [toastOpen, setToastOpen] = useState(false)
    return (
        <div className='bot-admin info-section'>
            <div className='section-title'>
                <p>管理员激活</p>
                <p className='section-subtitle'>
                    通过管理员的微信私聊机器人，可以对机器人进行管理。支持的命令为：配置、学习、帮助
                </p>
            </div>
            <CopyToClipboard
                text={activeCode}
                onCopy={() => {
                    setToastOpen(true)
                }}
            >
                <p className='active-code'>{activeCode}</p>
            </CopyToClipboard>

            <p className='active-tip-1'>单击复制激活码</p>
            <p className='active-tip-2'>
                请用管理员微信号给机器人微信号发送激活码激活
            </p>
            <Toast
                message='已复制'
                color='success'
                position='top'
                isOpen={toastOpen}
                onClose={() => setToastOpen(false)}
            />
        </div>
    )
}

interface BindBotDropProps {
    botSettings: BotSettings
    activeCode: string
    onUnbindDrop: () => void
}

const BindBotDrop = ({
    botSettings,
    activeCode,
    onUnbindDrop,
}: BindBotDropProps) => {
    const [toastOpen, setToastOpen] = useState(false)
    return (
        <div className='bot-admin bot-drop info-section'>
            <div className='section-title'>
                <p>机器人掉线提醒</p>
                <p className='section-subtitle'>
                    当机器人掉线时，可及时收到掉线通知，请复制粘贴以下激活码进行激活操作
                </p>
            </div>
            <CopyToClipboard
                text={activeCode}
                onCopy={() => {
                    setToastOpen(true)
                }}
            >
                <p className='active-code'>{activeCode}</p>
            </CopyToClipboard>

            <p className='active-tip-1'>注：点击复制激活码</p>
            <p className='active-tip-2'>发送激活码给公众号激活掉线提醒</p>
            {botSettings.bind_manager && (
                <span className='drop-operate' onClick={() => onUnbindDrop()}>
                    解绑
                </span>
            )}
            <Toast
                message='已复制'
                color='success'
                position='top'
                isOpen={toastOpen}
                onClose={() => setToastOpen(false)}
            />
        </div>
    )
}
const WorkTime: React.FC = () => {
    const botSet = useSelector<ReduxStore, BotSet>((store) => store.botSet)
    const insertStr = (soure, start, newStr) => {
        return soure.slice(0, start) + newStr + soure.slice(start)
    }
    const [startDate, setStartDate] = useState<string>('00:00')
    const [endDate, setEndDate] = useState<string>('24:00')
    const [toastOpen, setToastOpen] = useState(false)

    const setTime = async (param: Object) => {
        await updateBoReplySettings(param)
    }

    useEffect(() => {
        if (botSet) {
            if (botSet.bot_open_time || botSet.bot_open_time === '0000') {
                const bot_open = botSet.bot_open_time
                const bot_open_data = insertStr(bot_open, 2, ':')
                if (botSet.bot_open_time !== startDate) {
                    setStartDate(bot_open_data)
                }
            }
            if (botSet.bot_close_time || botSet.bot_close_time === '0000') {
                const bot_close = botSet.bot_close_time
                const bot_close_data = insertStr(bot_close, 2, ':')
                if (botSet.bot_close_time !== endDate) {
                    setEndDate(bot_close_data)
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [botSet])

    const timeChange = (value: string, type: string) => {
        // console.log('时间变化', value, type)
        if (
            (type === 'start' && value >= endDate) ||
            (type === 'end' && startDate >= value)
        ) {
            setToastOpen(true)
            setStartDate('08:00')
            setEndDate('18:00')
            return
        }
        if (type === 'start') {
            const startTime = value.split(':').join('')
            setStartDate(value)
            setTime({ bot_open_time: startTime })
        }
        if (type === 'end') {
            setEndDate(value)
            const endTime = value.split(':').join('')
            setTime({ bot_close_time: endTime })
        }
    }
    return (
        <div className='work-time-section info-section'>
            <div className='section-title'>
                <p>工作时间</p>
                <p className='section-subtitle'>
                    机器人只有在工作时间，才会进行自动回复；非工作时间不会有任何响应，但会一直进行数据统计。
                </p>
            </div>
            <div className='work-time-content'>
                <span>每天</span>
                <IonDatetime
                    placeholder='选择开始时间'
                    value={startDate}
                    cancelText='取消'
                    doneText='确定'
                    displayFormat='HH:mm'
                    className='time-button'
                    onIonChange={(e) => timeChange(e.detail.value!, 'start')}
                />
                <label>-</label>
                <IonDatetime
                    placeholder='选择结束时间'
                    value={endDate}
                    cancelText='取消'
                    doneText='确定'
                    displayFormat='HH:mm'
                    className='time-button'
                    // ionBlur={() => dataBlur()}
                    // min={startDate}
                    onIonChange={(e) => timeChange(e.detail.value!, 'end')}
                />
            </div>
            <Toast
                message='开始时间不能大于结束时间'
                color='error'
                position='top'
                isOpen={toastOpen}
                onClose={() => setToastOpen(false)}
            />
        </div>
    )
}
const BindWechat: React.FC = () => {
    const dispatch = useDispatch()
    const history = useHistory()
    const userInfo = useSelector<ReduxStore, UserModel>(
        (store) => store.userInfo as UserModel
    )
    // console.log(userInfo)
    const botSettings = useSelector<ReduxStore, BotSettings>(
        (store) => store.settingsInfo as any
    )
    let [defaultReply, setDefaultReply] = useState<string>('')
    let [replyConfig, setReplyConfig] = useState<any>(null)
    const [loadingOptions] = useState<LoadingProps>({
        isOpen: false,
        message: '解绑中，请稍后...',
    })
    const [unbindType, setUnbindType] = useState<UserType>('bot')
    const [unbindAlertOptions, setUnbindAlerOptions] = useState({
        onDidDismiss: () => {
            setUnbindAlerOptions({
                ...unbindAlertOptions,
                isOpen: false,
            })
        },
        isOpen: false,
        message: `确认解绑机器人吗？`,
    })
    const [bindSuccessAlertOptions, setBindSuccessAlerOptions] = useState({
        onDidDismiss: () => {
            setBindSuccessAlerOptions({
                ...bindSuccessAlertOptions,
                isOpen: false,
            })
        },
        isOpen: false,
        message: `<div class="bind-success-dialog">
        <p class="bind-success-title" >恭喜你，绑定成功</p>
        <p class="bind-success-tip">1、请不要在电脑上扫码登录或更换手机登录机器人微信账号，否则机器人将会掉线。</p>
        <p class="bind-success-tip">2、手机微信页面顶部的“iPad微信已登录”通知是微信机器人服务，请不要点击退出。</p>
    </div>`,
    })
    useIonViewDidEnter(() => {
        let bindSuccess = localStorage.getItem('BindSuccess')
        if (bindSuccess) {
            setBindSuccessAlerOptions({
                ...bindSuccessAlertOptions,
                isOpen: true,
            })
        }
        loadBotSettings()
        loadReplyConfig()
        localStorage.removeItem('BindSuccess')
    })
    useIonViewDidLeave(() => {})
    // if (!botSettings) return null
    // 获取机器人配置（机器人绑定信息）
    const loadBotSettings = async () => {
        try {
            let res = await getWechatBotSettings()
            dispatch(setBotSettingsInfo(res))
            if (!res.is_online) {
                history.replace(BindWechatPage)
            }
        } catch (error) {
            console.error(error)
        }
    }
    // 获取机器人回复
    const loadReplyConfig = async () => {
        try {
            let res = await getReplyConfig(userInfo.app_hash)
            if (res.data.replyConfig.successfully) {
                let reply =
                    res.data.replyConfig.rows[0].bot.general_reply_list[0]
                if (reply) {
                    let content = JSON.parse(reply.answer).Content
                    setDefaultReply(content)
                    setReplyConfig(reply)
                }
            }
        } catch (error) {
            console.error(error)
        }
    }
    // 更新默认回复
    const handleDefaultReplyUpdate = async () => {
        try {
            let reply = {
                answer_id: replyConfig.answer_id,
                answer_type: replyConfig.answer_type,
                answer: JSON.stringify({ Content: defaultReply }),
            }
            console.log(reply)
            await updateReplyConfig({
                appHash: userInfo.app_hash,
                replyList: [reply],
            })
        } catch (error) {
            console.error(error)
        }
    }
    // 解绑机器人
    const handleUnbindBot = async () => {
        try {
            // await unbindWechatBot()
            await postUserAction('wechaty_unbind')
            let timer = setTimeout(() => {
                loadBotSettings()
                clearTimeout(timer)
            }, 2 * 1000)
        } catch (error) {
            console.error(error)
        }
    }
    const handleUnbindAdmin = async () => {
        try {
            await unbindBotAdmin()
            let timer = setTimeout(() => {
                loadBotSettings()
                clearTimeout(timer)
            }, 1000)
        } catch (error) {
            console.error(error)
        }
    }

    const onUnbindDrop = async () => {
        try {
            await unbindWx()
            loadBotSettings()
        } catch (error) {
            console.error(error)
        }
    }

    return (
        <IonPage>
            <IonContent className='bind-wechat-content'>
                <Header title='机器人' />

                <WechatUserComp
                    type='bot'
                    settings={botSettings}
                    onUnbind={(type) => {
                        setUnbindType(type)
                        setUnbindAlerOptions({
                            ...unbindAlertOptions,
                            isOpen: true,
                            message: '确认解绑机器人吗？',
                        })
                    }}
                />
                <BotRunStatistics />

                <div
                    className='info-section groupDataArrowBox'
                    onClick={() => history.push(GroupDataStatisticsPage)}
                >
                    <p>群数据分析</p>
                    <img
                        src={ArrowRightIcon}
                        alt='icon'
                        className='groupDataArrow'
                    />
                </div>

                <BotDefaultResponse
                    value={defaultReply}
                    onChange={setDefaultReply}
                    onBlur={handleDefaultReplyUpdate}
                />
                {botSettings && !botSettings.admin_wxid && (
                    <BindBotAdmin activeCode={botSettings.active_code} />
                )}
                {botSettings && (
                    <BindBotDrop
                        botSettings={botSettings}
                        activeCode={botSettings.wechat_active_code}
                        onUnbindDrop={onUnbindDrop}
                    />
                )}
                {botSettings && botSettings.admin_wxid && (
                    <WechatAdminComp
                        settings={botSettings}
                        onUnbind={(type: UserType) => {
                            setUnbindType(type)
                            setUnbindAlerOptions({
                                ...unbindAlertOptions,
                                isOpen: true,
                                message: '确认解绑管理员吗？',
                            })
                        }}
                    />
                )}
                <div className='contact-select-section info-section'>
                    <div className='section-title'>
                        <p>回复对象</p>
                        <p className='section-subtitle'>机器人服务的群或好友</p>
                    </div>
                    <ContactSelector contactType='GROUP' />
                </div>
                <ContactSelector
                    contactType='FRIEND'
                    className='contact-select-section info-section'
                />
                {/* <div className="contact-select-section info-section">
                    <ContactRadioGroup title="好友" allLabel="全部好友" appointLabel="指定好友" />
                </div> */}
                <WorkTime />
                <IonAlert
                    cssClass='bind-success'
                    {...bindSuccessAlertOptions}
                    buttons={[
                        {
                            text: '确认',

                            handler: () => {},
                        },
                    ]}
                />
                <IonAlert
                    {...unbindAlertOptions}
                    buttons={[
                        {
                            text: '取消',
                            handler: () => {
                                setUnbindAlerOptions({
                                    ...unbindAlertOptions,
                                    isOpen: false,
                                })
                            },
                        },
                        {
                            text: '确认',
                            handler: () => {
                                setUnbindAlerOptions({
                                    ...unbindAlertOptions,
                                    isOpen: false,
                                })
                                if (unbindType === 'bot') {
                                    handleUnbindBot()
                                } else {
                                    handleUnbindAdmin()
                                }
                            },
                        },
                    ]}
                />
            </IonContent>
            <IonLoading {...loadingOptions} />
        </IonPage>
    )
}
export default BindWechat
